import { render, staticRenderFns } from "./FormPedidoVenda.vue?vue&type=template&id=0057e670&scoped=true&"
import script from "./FormPedidoVenda.vue?vue&type=script&lang=js&"
export * from "./FormPedidoVenda.vue?vue&type=script&lang=js&"
import style0 from "./FormPedidoVenda.vue?vue&type=style&index=0&id=0057e670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057e670",
  null
  
)

export default component.exports